import type { ButtonHTMLAttributes, ReactNode } from "react";

type Variant = "primary" | "secondary" | "danger" | "ghost";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  loading?: boolean;
  children: ReactNode;
}

export default function Button({ variant = "secondary", loading, children, className = "", disabled, ...rest }: Props) {
  return (
    <button
      disabled={disabled || loading}
      className={`bo-btn bo-btn--${variant} ${className}`}
      {...rest}
    >
      {loading ? "…" : children}
    </button>
  );
}
